import { Component, OnInit } from '@angular/core';

@Component({
    selector: "app-service-soudure",
    templateUrl: "./service-soudure.component.html",
    styleUrls: ["./service-soudure.component.scss"],
})
export class ServiceSoudureComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
